module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25684",
      "conversations-internal-schema": "static-1.12368",
      "head-dlb": "static-1.4754",
      "hs-test-utils": "static-1.7709",
      "hubspot-url-utils": "static-1.3887",
      "HubStyleTokens": "static-2.11147",
      "I18n": "static-7.1551",
      "jasmine-runner": "static-1.6180",
      "quartz": "static-1.6613",
      "react": "static-7.177",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.482",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5852",
      "enviro": "static-4.387",
      "hs-promise-rejection-tracking": "static-1.5291",
      "PortalIdParser": "static-2.349",
      "raven": "static-3.5624",
      "raven-hubspot": "static-1.5931",
      "bend-plugin-trellis-migration": "static-1.3157",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17551",
      "cv-backend-services": "static-1.1481",
      "hub-http": "static-1.5872",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4378",
      "quartz-config": "static-1.391",
      "quartz-core": "static-1.5832",
      "transmute": "static-2.85",
      "HeadJS": "static-2.697",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7368",
      "framer-motion": "static-1.66",
      "hs-test-utils-bend-plugin": "static-1.2820",
      "msw": "static-1.39",
      "react-redux": "static-7.66",
      "redux": "static-4.16",
      "testing-library": "static-1.146",
      "foundations-theming": "static-1.4129",
      "i18n-data": "static-1.215",
      "metrics-js": "static-1.9360",
      "moment-timezone": "static-5.77",
      "react-utils": "static-2.5106",
      "jasmine": "static-4.4056",
      "history": "static-4.47",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.60",
      "styled-components": "static-2.84",
      "UIComponents": "static-3.8094",
      "visitor-ui-component-library-icons": "static-1.5663",
      "bender-build-tools": "static-1.2847",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4373",
      "apollo-stack-hubspot": "static-3.80",
      "classnames": "static-2.10",
      "cssUtils": "static-1.710",
      "customer-data-objects": "static-1.7340",
      "customer-data-ui-utilities": "static-1.9549",
      "data-fetching-client": "static-1.9401",
      "FileManagerCore": "static-1.38183",
      "FileManagerLib": "static-1.38324",
      "foundations-assets": "static-1.4556",
      "graphql": "static-1.76",
      "hs-promise-utils": "static-1.5315",
      "hubspot-apollo-client": "static-1.4604",
      "icons": "static-2.616",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.93",
      "rpc-client-utils": "static-1.4332",
      "salesImages": "static-1.519",
      "timezone-utils": "static-2.4968",
      "ui-gdpr-components": "static-1.10070",
      "ts-schema": "static-1.3835",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.130",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.778",
      "hubspotter-http": "static-1.4409",
      "mobile-manifest-mixins": "static-1.470",
      "quartz-auth": "static-1.288",
      "quartz-head": "static-1.278",
      "quartz-i18n": "static-1.288",
      "quartz-routing": "static-1.43",
      "quartz-test": "static-1.288",
      "quick-fetch": "static-1.3660",
      "react-rhumb": "static-1.16357",
      "react-router-dom": "static-5.26",
      "usage-tracker-container": "static-1.7048",
      "ui-fonts": "static-1.409",
      "bend-plugin-foundations-components": "static-1.3637",
      "floating-ui": "static-1.50",
      "foundations-theming-specialty": "static-1.1845",
      "hs-story-utils": "static-1.9151",
      "tanstack-table": "static-1.49",
      "trellis-assets": "static-1.1010",
      "ui-images": "static-2.1071",
      "bend-plugin-foundations-theming": "static-1.2612",
      "foundations-theming-base": "static-1.3114",
      "stylex": "static-1.26",
      "HubStyle": "static-2.11455",
      "sassPrefix": "static-1.150",
      "inbound-db-properties-service-client": "static-1.3609",
      "property-translator": "static-1.5138",
      "react-dnd-compat": "static-1.4348",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8165",
      "audio-components": "static-1.5509",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.22684",
      "FileManagerImages": "static-1.35835",
      "immerable": "static-1.3879",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8599",
      "urlinator": "static-1.4257",
      "usage-tracker-core": "static-1.6908",
      "video-components": "static-1.12349",
      "video-data-lib": "static-1.34004",
      "video-embed": "static-1.34838",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.63",
      "hub-http-shared-msw-handlers": "static-1.9289",
      "hubspotter-http-shared-msw-handlers": "static-1.9287",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20063",
      "chirp-fetch": "static-1.1606",
      "ContentUtils": "static-1.67426",
      "copilot-toolkit": "static-1.10353",
      "sanitize": "static-1.4199",
      "sanitize-text": "static-1.7864",
      "content-assistance-lib": "static-1.7345",
      "usage-tracker": "static-1.7058",
      "video-components-external": "static-1.10346",
      "content-icons-ui": "static-1.2130",
      "social-insights-client-types": "static-1.21143",
      "SharedI18nStrings": "static-1.179",
      "outpost": "static-1.3936",
      "chatspot-client-types": "static-1.10385",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4531",
      "integrations-lib": "static-1.15196",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5300",
      "magpie-types": "static-1.4760",
      "simple-logging-lib": "static-1.2775",
      "superstore": "static-1.4497",
      "ui-addon-video-player": "static-1.8432",
      "ui-coaching-tips": "static-1.27761",
      "content-media-composition-data-lib": "static-1.11204",
      "content-media-compositions": "static-2.15211",
      "idb-keyval": "static-1.38",
      "media-bridge-lib": "static-1.18455",
      "flux-actions": "static-1.300",
      "frontend-preferences-client": "static-1.7649",
      "integrations-error-boundary-lib": "static-1.12611",
      "integrations-tracking-lib": "static-1.5307",
      "laboratory-lib": "static-3.6868",
      "native-integrations-shared-strings": "static-1.7513",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10097",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.10853",
      "ui-shepherd-react": "static-3.9868",
      "reactive-lib": "static-1.450",
      "growth-onboarding-feedback-components": "static-1.6310",
      "hls.js": "static-1.33",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2720",
      "foundations-components-test-utils": "static-1.4851",
      "react-dlb": "static-1.70",
      "crm-record-cards-service-types": "static-1.3382",
      "framework-data-schema-resolvers": "static-1.6592",
      "location-customization-utils-lib": "static-1.8340",
      "batch-promise": "static-1.1254",
      "conditional-properties-service-client": "static-1.3554",
      "crm-pipelines-api-client-types": "static-1.3895",
      "framework-builder-read-service-client": "static-1.3778",
      "framework-data-schema-quick-fetch": "static-1.6497",
      "inbound-db-meta-service-client": "static-1.3391",
      "multi-currency-client-types": "static-1.3449",
      "persist-promise": "static-1.3411"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25684",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12368",
      "head-dlb": "/head-dlb/static-1.4754",
      "hs-test-utils": "/hs-test-utils/static-1.7709",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3887",
      "HubStyleTokens": "/HubStyleTokens/static-2.11147",
      "I18n": "/I18n/static-7.1551",
      "jasmine-runner": "/jasmine-runner/static-1.6180",
      "quartz": "/quartz/static-1.6613",
      "react": "/react/static-7.177",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.482",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5852",
      "enviro": "/enviro/static-4.387",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
      "PortalIdParser": "/PortalIdParser/static-2.349",
      "raven": "/raven/static-3.5624",
      "raven-hubspot": "/raven-hubspot/static-1.5931",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3157",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17551",
      "cv-backend-services": "/cv-backend-services/static-1.1481",
      "hub-http": "/hub-http/static-1.5872",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4378",
      "quartz-config": "/quartz-config/static-1.391",
      "quartz-core": "/quartz-core/static-1.5832",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.697",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7368",
      "framer-motion": "/framer-motion/static-1.66",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2820",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.66",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.146",
      "foundations-theming": "/foundations-theming/static-1.4129",
      "i18n-data": "/i18n-data/static-1.215",
      "metrics-js": "/metrics-js/static-1.9360",
      "moment-timezone": "/moment-timezone/static-5.77",
      "react-utils": "/react-utils/static-2.5106",
      "jasmine": "/jasmine/static-4.4056",
      "history": "/history/static-4.47",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.60",
      "styled-components": "/styled-components/static-2.84",
      "UIComponents": "/UIComponents/static-3.8094",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5663",
      "bender-build-tools": "/bender-build-tools/static-1.2847",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4373",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.710",
      "customer-data-objects": "/customer-data-objects/static-1.7340",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9549",
      "data-fetching-client": "/data-fetching-client/static-1.9401",
      "FileManagerCore": "/FileManagerCore/static-1.38183",
      "FileManagerLib": "/FileManagerLib/static-1.38324",
      "foundations-assets": "/foundations-assets/static-1.4556",
      "graphql": "/graphql/static-1.76",
      "hs-promise-utils": "/hs-promise-utils/static-1.5315",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4604",
      "icons": "/icons/static-2.616",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.93",
      "rpc-client-utils": "/rpc-client-utils/static-1.4332",
      "salesImages": "/salesImages/static-1.519",
      "timezone-utils": "/timezone-utils/static-2.4968",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10070",
      "ts-schema": "/ts-schema/static-1.3835",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.130",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.778",
      "hubspotter-http": "/hubspotter-http/static-1.4409",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.470",
      "quartz-auth": "/quartz-auth/static-1.288",
      "quartz-head": "/quartz-head/static-1.278",
      "quartz-i18n": "/quartz-i18n/static-1.288",
      "quartz-routing": "/quartz-routing/static-1.43",
      "quartz-test": "/quartz-test/static-1.288",
      "quick-fetch": "/quick-fetch/static-1.3660",
      "react-rhumb": "/react-rhumb/static-1.16357",
      "react-router-dom": "/react-router-dom/static-5.26",
      "usage-tracker-container": "/usage-tracker-container/static-1.7048",
      "ui-fonts": "/ui-fonts/static-1.409",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3637",
      "floating-ui": "/floating-ui/static-1.50",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1845",
      "hs-story-utils": "/hs-story-utils/static-1.9151",
      "tanstack-table": "/tanstack-table/static-1.49",
      "trellis-assets": "/trellis-assets/static-1.1010",
      "ui-images": "/ui-images/static-2.1071",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2612",
      "foundations-theming-base": "/foundations-theming-base/static-1.3114",
      "stylex": "/stylex/static-1.26",
      "HubStyle": "/HubStyle/static-2.11455",
      "sassPrefix": "/sassPrefix/static-1.150",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3609",
      "property-translator": "/property-translator/static-1.5138",
      "react-dnd-compat": "/react-dnd-compat/static-1.4348",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8165",
      "audio-components": "/audio-components/static-1.5509",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.22684",
      "FileManagerImages": "/FileManagerImages/static-1.35835",
      "immerable": "/immerable/static-1.3879",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8599",
      "urlinator": "/urlinator/static-1.4257",
      "usage-tracker-core": "/usage-tracker-core/static-1.6908",
      "video-components": "/video-components/static-1.12349",
      "video-data-lib": "/video-data-lib/static-1.34004",
      "video-embed": "/video-embed/static-1.34838",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.63",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9289",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9287",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20063",
      "chirp-fetch": "/chirp-fetch/static-1.1606",
      "ContentUtils": "/ContentUtils/static-1.67426",
      "copilot-toolkit": "/copilot-toolkit/static-1.10353",
      "sanitize": "/sanitize/static-1.4199",
      "sanitize-text": "/sanitize-text/static-1.7864",
      "content-assistance-lib": "/content-assistance-lib/static-1.7345",
      "usage-tracker": "/usage-tracker/static-1.7058",
      "video-components-external": "/video-components-external/static-1.10346",
      "content-icons-ui": "/content-icons-ui/static-1.2130",
      "social-insights-client-types": "/social-insights-client-types/static-1.21143",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
      "outpost": "/outpost/static-1.3936",
      "chatspot-client-types": "/chatspot-client-types/static-1.10385",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4531",
      "integrations-lib": "/integrations-lib/static-1.15196",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5300",
      "magpie-types": "/magpie-types/static-1.4760",
      "simple-logging-lib": "/simple-logging-lib/static-1.2775",
      "superstore": "/superstore/static-1.4497",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27761",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11204",
      "content-media-compositions": "/content-media-compositions/static-2.15211",
      "idb-keyval": "/idb-keyval/static-1.38",
      "media-bridge-lib": "/media-bridge-lib/static-1.18455",
      "flux-actions": "/flux-actions/static-1.300",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7649",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12611",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5307",
      "laboratory-lib": "/laboratory-lib/static-3.6868",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7513",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10097",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10853",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9868",
      "reactive-lib": "/reactive-lib/static-1.450",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6310",
      "hls.js": "/hls.js/static-1.33",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2720",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4851",
      "react-dlb": "/react-dlb/static-1.70",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3382",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6592",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8340",
      "batch-promise": "/batch-promise/static-1.1254",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3554",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3895",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3778",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6497",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3391",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3449",
      "persist-promise": "/persist-promise/static-1.3411"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};